import secondaryComponents from "../../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import primaryComponents from "../../../../../components/primaryComponents";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import useWaybills from "./useWaybills";
import Icon from "../../../../../assets/icons";
import { pathConstants } from "../../../../../routes/pathContants";

const Waybills = () => {
  const {
    isFetchingWaybills,
    storeList,
    currentStore,
    metaDetails,
    waybills,
    search,
    filterByDate,
    handleFetchingWaybills,
    filterByStoreId,
    gotoPage,
    filterBySearch,
    navigate,
  } = useWaybills();
  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Procurement - Waybills"
      description="View all waybills"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 0.3 } }}
          exit={{ opacity: 0 }}
          className={`${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Waybills</h4>
            <p>Manage all your generated waybills</p>
          </div>
          <div className={globalStyles.pageHeaders}>
            <p>{waybills?.length} Waybills</p>
            <secondaryComponents.NavigateWithPermission
              permissionParentKey={"Inventory Management"}
              permissionChildKey="can_generate_waybill"
            >
              <primaryComponents.Button
                classNames="btn btn--primary"
                onClick={() =>
                  navigate(pathConstants.PROCUREMENT_GENERATE_WAYBILL)
                }
              >
                <img src={Icon.plusIcon} className="mr-1" alt="section" />{" "}
                <span>Generate Waybill</span>
              </primaryComponents.Button>
            </secondaryComponents.NavigateWithPermission>
          </div>
          <div className={globalStyles.tableWrapper}>
            <div className={globalStyles.tableHeader}>
              <primaryComponents.SearchField
                classNames={globalStyles.searchField}
                placeholder="Search by waybill no., order ID, customer, driver name, vehicle no. or logistics company"
                trigger={(value) => filterBySearch(value)}
                value={search.get("query") || ""}
                triggerOnInput={true}
                showsearchBtn={true}
              />
              <div style={{ width: "230px" }}>
                <primaryComponents.SelectField
                  options={[{ name: "All stores", id: null }, ...storeList]}
                  idKey="id"
                  nameKey="name"
                  onChange={filterByStoreId}
                  value={
                    storeList?.find(
                      (storeItem) => `${storeItem?.id}` === `${currentStore}`,
                    )?.name || "All stores"
                  }
                  floatError={false}
                  classNames="store-select"
                />
              </div>

              <primaryComponents.DateRangeInput
                startDate={search.get("start_date")}
                endDate={search.get("end_date")}
                onChange={filterByDate}
                classNames=""
              />
            </div>
            <secondaryComponents.LoaderHelper
              isLoading={isFetchingWaybills}
              classNames="mt-5"
            >
              <secondaryComponents.WaybillsTable
                metaDetails={metaDetails}
                waybills={waybills}
                handleFetchWaybills={handleFetchingWaybills}
                gotoPage={gotoPage}
              />
            </secondaryComponents.LoaderHelper>
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};

export default Waybills;
